import { Inject, Injectable } from '@angular/core';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';
import { THEME_CONFIG } from './theme.config.types';

@Injectable({
	providedIn: 'root',
})
export class ThemeConfigService {
	private _config: BehaviorSubject<any>;

	constructor(@Inject(THEME_CONFIG) config: any) {
		this._config = new BehaviorSubject(config);
	}
	set config(value: any) {
		const config = merge({}, this._config.getValue(), value);
		this._config.next(config);
	}
	get config$(): Observable<any> {
		return this._config.asObservable();
	}
	reset(): void {
		this._config.next(this.config);
	}
}
